import '../../styles/ShowLayers.css'
import Selector from '../../Selector'
import InfoStatus from '../../InfoStatus'
import Action from '../../Action'
import {fetchData} from '../../../hooks/fetchData'
import { useFetch } from '../../../hooks/useFetch'
import { Suspense, useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl';
import { capitalizeFirstLetter } from '../../../utils/utils'
import { lang } from '../../generales/traduction'

const ShowLayers =(props)=>{
    // console.log(props.capas)
    // console.log(Object.keys(props.capas))
   
    
    const [resultList,setResultList]=useState([])
    const [inputIp,setInputIP]=useState("")
    // console.log(resultList)
    const closeFindHost=()=>{
        const popups = document.querySelectorAll('.custom-popup-findHost'); 
        popups.forEach(popup => {
    //    console.log(popups)
      popup.remove();
      });
      setResultList([])
      setInputIP("")
    }
    const [excepciones,setExcepciones]=useState(true)
    // console.log(excepciones)
    function getNameById(id) {
        // console.log(props.dataAgencies)
        const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
        // return agency ? agency.name : null;
        return ((id==0)?'MANTTO':(agency ? agency.shortName : null));
      }
      function getColorById(id) {
        const agency = props.dataAgencies.data.data.find(agency => agency.id === id);
        // return agency ? agency.color : null;
        return ((id==0)?'#757474':(agency ? agency.color : null));
      }
    const showExecptions=()=>{
        if(excepciones){
            setExcepciones(false)
            const popups = (props.mode=="")?document.querySelectorAll('.custom-popup-except'):document.querySelectorAll('.custom-popup-except-white');
      
      popups.forEach(popup => {
       
      popup.remove();
      });
        }else{
            setExcepciones(true)
            if(Object.keys(props.exceptData.map).length!==0){
                props.exceptions.forEach((feature) => {
                    const coordinates = feature.geometry.coordinates.slice();
                    const val = feature.properties.lecturas; // Asegúrate de tener esta propiedad en tus datos
                    const agency_id = feature.properties.exception_agency_id; 
                    const activo=feature.properties.activo;
                    
                    
                    let popup = new mapboxgl.Popup({
                      className: (props.mode=="")?'custom-popup-except':'custom-popup-except-white',
                      closeButton: false,
                      closeOnClick: false
                  })
                      .setLngLat(coordinates)
                          .setHTML(`<div class='cont-except' style='border: 1px solid #ffffff;'>
                      
                      <div class='valexcept' style='background: ${getColorById(agency_id)}'><div class='txtexcept'  >${getNameById(agency_id)}</div><br><br></div>
                          </div>`)
                          .addTo(props.exceptData.map);
                          return popup;
                  });
            }
        }
        
    }
    const handleClick=(element,index)=>{
        if(props.capas[index].show){
            props.mapAux.removeLayer(props.capas[index].id);
            props.mapAux.removeSource(props.capas[index].id);
        }else{
            if(index<Object.keys(props.capas).length-1){
                let i=index+1;
                let flag=true
                do{
                    // console.log(i,flag)
                    if(props.capas[i].show){
                        if(props.capas[index].source!=null){
                            props.mapAux.addSource(props.capas[index].id,props.capas[index].source)
                        }
                        props.mapAux.addLayer(props.capas[index].layer,props.capas[i].id)
                        flag=false
                    }else{
                        i++;
                    }
                }while(flag && i<Object.keys(props.capas).length)
                if(flag && i==Object.keys(props.capas).length){
                    if(props.capas[index].source!=null){
                        props.mapAux.addSource(props.capas[index].id,props.capas[index].source)
                    }
                    props.mapAux.addLayer(props.capas[index].layer)
                }
            }else{
                // console.log('muestra la capa ',props.capas[index].id)
                if(props.capas[index].source!=null){
                    props.mapAux.addSource(props.capas[index].id,props.capas[index].source)
                }
                props.mapAux.addLayer(props.capas[index].layer)
            }
            


        
        
        }
        props.setCapas((prevCapas) => ({
            ...prevCapas,
            [index]: {
              ...prevCapas[index],
              show: !prevCapas[index].show,
            },
          }));
    }
    const [isOpen, setIsOpen] = useState(false);

    const toggleCapas = () => {
        setIsOpen(!isOpen);
    };

    return(
        <div style={{position: 'relative'}}>
            <button className="btn-capas" onClick={toggleCapas}>
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                    <rect x="1" y="2.5" width="14" height="3" rx="1.2" fill="#1a56db"/>
                    <rect x="1" y="7" width="14" height="3" rx="1.2" fill="#1a56db" opacity=".55"/>
                    <rect x="1" y="11.5" width="14" height="2" rx="1" fill="#1a56db" opacity=".28"/>
                </svg>
                {lang[props.languaje]['capas'].toUpperCase()}
            </button>
            
            {isOpen && (
                <div className="panel-capas" style={{top: '42px', left: 0, display: 'block'}}>
                    <div className="capas-title">{lang[props.languaje]['capas'].toUpperCase()}</div>
                    
                    {Object.keys(props.capas).length === 0 ? (
                        <div style={{fontSize: '11px', padding: '10px'}}>{capitalizeFirstLetter(lang[props.languaje]['cargando'])}...</div>
                    ) : (
                        Object.values(props.capas).map((element, index) => (
                            <div 
                                className="capas-item" 
                                key={index} 
                                onClick={() => {
                                    handleClick(element, index);
                                    if(element.name === 'Excepciones') {
                                        showExecptions();
                                    }
                                }}
                            >
                                <div className={`capas-cb ${element.show ? 'checked' : ''}`} style={{
                                    width: '14px', 
                                    height: '14px', 
                                    border: '1.5px solid var(--b1)', 
                                    borderRadius: '3px', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    background: element.show ? 'var(--bl5)' : 'transparent',
                                    borderColor: element.show ? 'var(--bl)' : 'var(--b1)'
                                }}>
                                    {element.show && (
                                        <svg width="9" height="9" viewBox="0 0 9 9">
                                            <polyline points="1.5,4.5 3.5,7 7.5,2" fill="none" stroke="#1a56db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    )}
                                </div>
                                {element.name}
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    )
}

export default ShowLayers